// extracted by mini-css-extract-plugin
export default {"OAuthEditor__LinkContainer":"OAuthEditor_OAuthEditor__LinkContainer__p1u12","OAuthEditor__ManageLink":"OAuthEditor_OAuthEditor__ManageLink__nThVS"};